(function (utils, _insiderConfig, _notifications) {

    var getUserData = function () {
        return utils.request.post('api/shop/eventing/v2/users/current').then(function (data) {
            if (data && data.id) {
                // Load notifications
                _notifications.getNotifications(data.id);
                // Configure insider object
                window.insider_object = {
                    "user": {
                        "uuid": data.id
                    }
                };
            }
        }).always(function () {
            // Load insider
            if (_insiderConfig.enabled) {
                utils.script.load(_insiderConfig.getScriptSrc());
            }
        });
    };

    getUserData();

})(utils, insiderConfig, Notifications);